const vps = state => state.discount.vps;
const monitoring = state => state.discount.monitoring;

const prize = state => state.discount.prize;

const sendStatus = state => state.discount.sendStatus;

export default {
  vps,
  monitoring,

  prize,

  sendStatus,
};
